{
  "CANNED_MGMT": {
    "HEADER": "الردود الجاهزة",
    "LEARN_MORE": "معرفة المزيد عن الاستجابات المعلبة",
    "DESCRIPTION": "الردود المسبقة هي قوالب رد مكتوبة مسبقاً تساعدك على الرد بسرعة على محادثة. يمكن للوكلاء كتابة حرف '/' يتبعه الرمز المختصر لإدراج رد مسبق أثناء محادثة. ",
    "COUNT": "{n} canned response | {n} canned responses",
    "HEADER_BTN_TXT": "إضافة رد جاهز",
    "LOADING": "جاري جلب الردود الجاهزة...",
    "SEARCH_PLACEHOLDER": "Search canned responses...",
    "NO_RESULTS": "No canned responses found matching your search",
    "SEARCH_404": "لا توجد عناصر مطابقة لهذا الاستعلام.",
    "LIST": {
      "404": "لا توجد ردود جاهزة متوفرة في هذا الحساب.",
      "TITLE": "إدارة الردود الجاهزة",
      "DESC": "الردود الجاهزة هي قوالب رسائل معدة مسبقاً يمكن استخدامها لتسريع كتابة الردود في المحادثات.",
      "TABLE_HEADER": {
        "SHORT_CODE": "كود مختصر",
        "CONTENT": "المحتوى",
        "ACTIONS": "الإجراءات"
      }
    },
    "ADD": {
      "TITLE": "إضافة رد جاهز",
      "DESC": "الردود الجاهزة هي قوالب رسائل معدة مسبقاً يمكن استخدامها لتسريع كتابة الردود في المحادثات.",
      "CANCEL_BUTTON_TEXT": "إلغاء",
      "FORM": {
        "SHORT_CODE": {
          "LABEL": "كود مختصر",
          "PLACEHOLDER": "من فضلك ادخل الكود مختصر.",
          "ERROR": "الكود مختصر مطلوب."
        },
        "CONTENT": {
          "LABEL": "رسالة",
          "PLACEHOLDER": "من فضلك ادخل نص لرسالة التي ترغب في حفظها كقالب لاستخدامها لاحقاُ.",
          "ERROR": "الرسالة مطلوبة."
        },
        "SUBMIT": "إرسال"
      },
      "API": {
        "SUCCESS_MESSAGE": "تم إضافة الرد الجاهز بنجاح.",
        "ERROR_MESSAGE": "تعذر الاتصال بالخادم، الرجاء المحاولة مرة أخرى لاحقاً"
      }
    },
    "EDIT": {
      "TITLE": "تعديل الرد الجاهز",
      "CANCEL_BUTTON_TEXT": "إلغاء",
      "FORM": {
        "SHORT_CODE": {
          "LABEL": "كود مختصر",
          "PLACEHOLDER": "من فضلك ادخل الكود المختصر.",
          "ERROR": "الكود المختصر مطلوب."
        },
        "CONTENT": {
          "LABEL": "رسالة",
          "PLACEHOLDER": "من فضلك ادخل نص للرسالة التي ترغب في حفظها كقالب لاستخدامها لاحقاُ.",
          "ERROR": "الرسالة مطلوبة."
        },
        "SUBMIT": "تسليم"
      },
      "BUTTON_TEXT": "تعديل",
      "API": {
        "SUCCESS_MESSAGE": "تم تحديث الرد الجاهز بنجاح.",
        "ERROR_MESSAGE": "تعذر الاتصال بالخادم، الرجاء المحاولة مرة أخرى لاحقاً"
      }
    },
    "DELETE": {
      "BUTTON_TEXT": "حذف",
      "API": {
        "SUCCESS_MESSAGE": "تم حذف الرد الجاهز بنجاح.",
        "ERROR_MESSAGE": "تعذر الاتصال بالخادم، الرجاء المحاولة مرة أخرى لاحقاً"
      },
      "CONFIRM": {
        "TITLE": "تأكيد الحذف",
        "MESSAGE": "هل أنت متأكد من الحذف ",
        "YES": "نعم، احذف ",
        "NO": "لا، احتفظ به "
      }
    }
  }
}
